import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { UI, tr as pick } from "./i18n";

const SiteCtx = createContext(null);

export const useSiteQuery = () =>
  useQuery({ queryKey: ["site"], queryFn: () => api.get("/public/site").then((r) => r.data), staleTime: 0, refetchOnWindowFocus: true });

const BLOG_UI = {
  tr: { news: "Blog", latestNews: "Son Yazılar", allNews: "Tüm yazılar", related: "Diğer Yazılar", search: "Yazılarda ara…", whoAmI: "Hakkımda" },
  en: { news: "Blog", latestNews: "Latest Posts", allNews: "All posts", related: "More Posts", search: "Search posts…", whoAmI: "About" },
};

export function SiteProvider({ lang, site, children }) {
  const base = UI[lang] || UI.tr;
  const ui = site.theme?.mode === "adaylik" ? base : { ...base, ...(BLOG_UI[lang] || BLOG_UI.tr) };
  const t = (o) => pick(o, lang);
  const subtitle = site.theme?.mode === "adaylik" ? t(site.profile?.title) : t(site.profile?.tagline) || t(site.profile?.title);
  const value = { lang, site, ui, t, subtitle };
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export const usePublic = (key, url, opts = {}) =>
  useQuery({ queryKey: key, queryFn: () => api.get(url).then((r) => r.data), retry: false, staleTime: 0, refetchOnWindowFocus: true, ...opts });
